import React from "react";
import { FaSwimmingPool, FaDumbbell, FaCar, FaPhone, FaWrench, FaShieldAlt, FaBuilding, FaBolt, FaParking, FaUsers } from "react-icons/fa";
import { MdOutlineElevator, MdOutlineSportsBasketball, MdOutlineWaterDrop } from "react-icons/md";

const allAmenities = {
  clubhouse: { name: "Club House", icon: <FaBuilding /> },
  powerBackup: { name: "Power Back Up", icon: <FaBolt /> },
  swimmingPool: { name: "Swimming Pool", icon: <FaSwimmingPool /> },
  lift: { name: "Lift", icon: <MdOutlineElevator /> },
  security: { name: "Security", icon: <FaShieldAlt /> },
  parking: { name: "Reserved Parking", icon: <FaCar /> },
  visitorParking: { name: "Visitor Parking", icon: <FaParking /> },
  intercom: { name: "Intercom Facility", icon: <FaPhone /> },
  maintenance: { name: "Maintenance Staff", icon: <FaWrench /> },
  gym: { name: "Gymnasium", icon: <FaDumbbell /> },
  rainWaterHarvesting: { name: "Rain Water Harvesting", icon: <MdOutlineWaterDrop /> },
  multipurposeCourts: { name: "Multipurpose Courts", icon: <MdOutlineSportsBasketball /> },
};

const Amenities = ({ amenitiesData }) => {
  // Filter only the true values from amenitiesData
  const filteredAmenities = Object.entries(amenitiesData)
    .filter(([key, value]) => value && allAmenities[key]) // Ensure the key exists in allAmenities
    .map(([key]) => allAmenities[key]);

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-4">Amenities</h2>
      {filteredAmenities.length > 0 ? (
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-4">
          {filteredAmenities.map((item, index) => (
            <div key={index} className="flex items-center justify-center p-4 border rounded-lg shadow-md bg-white">
              <div className="text-red-500 text-2xl mr-2">{item.icon}</div>
              <span className="text-gray-700 font-medium">{item.name}</span>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-gray-500">No amenities available</p>
      )}
    </div>
  );
};

export default Amenities;
